<template>
  <div 
    class="bill-tracks-container grid-view" 
    :class="{
      'exceded': call.participants.length+1>50
    }" 
    :tracks="call.participants.length+1"  
  >
    <Track :call="call" class="bill-track-1" />
    <Track
      v-for="(participant, index) in call.participants"
      :key="participant._id"
      :class="`bill-track-${index+2}`"
      :participant="participant"
      :call="call"
    />
  </div>
</template>

<script>
import Track from './track.vue'
export default {
  name: 'GridView',
  components: {
    Track,
  },
  props: {
    call: {
      type: Object,
      default: ()=>{return{}},
      require: true,
    },
  },
}
</script>

<style lang="scss">
$values: ( '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50' );
@each $value in $values {
  .bill-track-#{$value} {
    grid-area: area#{$value};
  }
}
.bill-tracks-container {
  flex: 1;
  display: grid;
  grid-gap: 5px;
  background-color: #6B6969;
  height: 100%;
  width: 100%;
  padding: 5px;
  &.grid-view {
    &[tracks="1"] {
      grid-template-areas: 
      'area1';
    }
    &[tracks="2"] {
      grid-template-areas: 
      'area1 area2';
    }
    &[tracks="3"] {
      grid-template-areas: 
      'area1 area2' 
      'area1 area3';
    }
    &[tracks="4"] {
      grid-template-areas: 
      'area1 area2' 
      'area3 area4';
    }
    &[tracks="5"] {
      grid-template-areas: 
      'area1 area2 area3' 
      'area1 area4 area5';
    }
    &[tracks="6"] {
      grid-template-areas: 
      'area1 area2 area3' 
      'area4 area5 area6';
    }
    &[tracks="7"] {
      grid-template-areas: 
      'area1 area2 area3 area4' 
      'area1 area5 area6 area7';
    }
    &[tracks="8"] {
      grid-template-areas: 
      'area1 area2 area3 area4' 
      'area5 area6 area7 area8';
    }
    &[tracks="9"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area1 area6 area7 area8 area9';
    }
    &[tracks="10"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10';
    }
    &[tracks="11"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area11 area11 area11 area11';
    }
    &[tracks="12"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area11 area12 area12 area12';
    }
    &[tracks="13"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area12 area13 area13';
    }
    &[tracks="14"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area14';
    }
    &[tracks="15"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15';
    }
    &[tracks="16"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area14' 
      'area15 area15 area16 area16 area16';
    }
    &[tracks="17"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area16 area16 area17 area17';
    }
    &[tracks="18"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area17 area18 area18';
    }
    &[tracks="19"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area19';
    }
    &[tracks="20"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20';
    }
    &[tracks="21"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area19' 
      'area20 area20 area21 area21 area21';
    }
    &[tracks="22"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area19' 
      'area20 area21 area21 area22 area22';
    }
    &[tracks="23"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area21 area22 area22 area23';
    }
    &[tracks="24"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area24';
    }
    &[tracks="25"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25';
    }
    &[tracks="26"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area24' 
      'area25 area25 area26 area26 area26';
    }
    &[tracks="27"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area24' 
      'area25 area26 area26 area27 area27';
    }
    &[tracks="28"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area27 area28 area28';
    }
    &[tracks="29"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area29';
    }
    &[tracks="30"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30';
    }
    &[tracks="31"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area29' 
      'area30 area30 area31 area31 area31';
    }
    &[tracks="32"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area29' 
      'area30 area31 area31 area32 area32';
    }
    &[tracks="33"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area32 area33 area33';
    }
    &[tracks="34"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area33 area34';
    }
    &[tracks="35"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35';
    }
    &[tracks="36"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area34' 
      'area35 area35 area36 area36 area36';
    }
    &[tracks="37"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area36 area37 area37 area37';
    }
    &[tracks="38"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area37 area37 area38 area38';
    }
    &[tracks="39"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area37 area38 area39 area39';
    }
    &[tracks="40"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area37 area38 area39 area40';
    }
    &[tracks="41"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area37 area38 area39 area39' 
      'area40 area40 area41 area41 area41';
    }
    &[tracks="42"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area37 area38 area39 area40' 
      'area41 area41 area42 area42 area42';
    }
    &[tracks="43"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area37 area38 area39 area40' 
      'area41 area42 area42 area43 area43';
    }
    &[tracks="44"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area37 area38 area39 area40' 
      'area41 area42 area43 area44 area44';
    }
    &[tracks="45"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area37 area38 area39 area40' 
      'area41 area42 area43 area44 area45';
    }
    &[tracks="46"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area37 area38 area39 area40' 
      'area41 area42 area43 area44 area44' 
      'area45 area45 area46 area46 area46';
    }
    &[tracks="47"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area37 area38 area39 area40' 
      'area41 area42 area43 area44 area45' 
      'area46 area46 area47 area47 area47';
    }
    &[tracks="48"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area37 area38 area39 area40' 
      'area41 area42 area43 area44 area45' 
      'area46 area47 area47 area48 area48';
    }
    &[tracks="49"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area37 area38 area39 area40' 
      'area41 area42 area43 area44 area45' 
      'area46 area47 area48 area49 area49';
    }
    &[tracks="50"] {
      grid-template-areas: 
      'area1 area2 area3 area4 area5' 
      'area6 area7 area8 area9 area10' 
      'area11 area12 area13 area14 area15' 
      'area16 area17 area18 area19 area20' 
      'area21 area22 area23 area24 area25' 
      'area26 area27 area28 area29 area30' 
      'area31 area32 area33 area34 area35' 
      'area36 area37 area38 area39 area40' 
      'area41 area42 area43 area44 area45' 
      'area46 area47 area48 area49 area50';
    }
    &.exceded {
      grid-template-columns: auto auto auto auto auto;
      div {
        grid-area: auto
      }
    }
  }
}

</style>